export default __webpack_public_path__ + "static/media/cliente03_color.7cb1626e.png";